import request from '@/api/request.js';

// 查询我发起的
export function applyList(data) {
    return request({
        url: 'workspace/pages/process/applyList',
        method: 'POST',
        data,
    });
}
// 查看我的待办
export function todoList(data) {
    return request({
        url: 'workspace/pages/process/toDoList',
        method: 'POST',
        data,
    });
}
// 查看我的已办
export function doneList(data) {
    return request({
        url: 'workspace/pages/process/doneList',
        method: 'POST',
        data,
    });
}
export function ccList(data) {
    return request({
        url: 'workspace/pages/process/ccList',
        method: 'POST',
        data,
    });
}
export function allApplyList(data) {
    return request({
        url: 'workspace/pages/process/allApply',
        method: 'POST',
        data,
    });
}
/**
 *  数据管理-导入
 */
export function importApplyExcel(query) {
    return request({
        url: 'workspace/pages/process/importApplyExcel',
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        method: 'POST',
        data: query,
    })
}
/**
 *  数据管理-导入：下载导入模板（返回 JSON，result 为模板文件地址）
 */
export function downloadImportTemplate(data) {
    return request({
        url: 'workspace/pages/process/downloadImportTemplate',
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        method: 'POST',
        data: data,
    })
}

// 数据管理-导出
export function exportApplyList(data) {
    return request({
        url: 'workspace/pages/process/exportApplyList',
        method: 'POST',
        data,
    });
}

// 数据管理-删除申请（单个传 processInstanceId，批量传 processInstanceIds）
export function deleteApply(data) {
    return request({
        url: 'workspace/pages/process/deleteApply',
        method: 'POST',
        data,
    });
}

// 查询表单组
export function getFormGroups(param) {
    return request({
        url: 'admin/form/group',
        method: 'get',
        params: param,
    });
}